module.exports = __webpack_public_path__ + "static/media/personal.fa2209c6.svg";